angular.module('lsnBase.deprecated.models')
  .factory('ApplicationAllowedChangesModel', ['LsnApplicationAllowedChangesModelV1',
    function(LsnApplicationAllowedChangesModelV1) {
      return LsnApplicationAllowedChangesModelV1;
    }
  ]);